export interface DNIData {
  EXPIRY: string;
  EXPEDITION_DATE: string;
  TYPE: string;
  MODEL_ID: string | null;
  STREET_ADDRESS: string;
  NAME: string;
  CITY_ADDRESS: string;
  EXPEDITOR: string;
  BIRTHDATE: string;
  NATIONALITY: string;
  ID_NUMBER: string;
  DOC_NUMBER: string;
  STATE_ADDRESS: string;
  TEST_GLOBAL_AUTHENTICITY_VALUE: string;
  TEST_GLOBAL_AUTHENTICITY_RATIO: string;
  SEX: string;
  SURNAME: string;
  FIRST_SURNAME: string;
  SECOND_SURNAME: string;
  Image1cut: string;
  Image2cut: string;
  ImagePhoto: string;
  ImageSignature: string;
  TEST_FACE_RECOGNITION_RATIO: string;
  TEST_FACE_RECOGNITION_VALUE: string;
  province_id: string;
  municipality_id: number | null;
  postal_code: string;
}

export interface SetCheckInAdult {
  code: string;
  icar_verified: boolean;
  without_images: boolean;
  contract_type_id: number;
  updated_fields: string[];
  dni: DNIData;
}

export class SetCheckInAdultBuilder {
  private checkInData: SetCheckInAdult;

  constructor(code: string) {
    this.checkInData = {
      code,
      icar_verified: true,
      without_images: true,
      contract_type_id: 0,
      updated_fields: [],
      dni: {
        EXPIRY: '',
        EXPEDITION_DATE: '',
        TYPE: '',
        MODEL_ID: null,
        STREET_ADDRESS: '',
        NAME: '',
        CITY_ADDRESS: '',
        EXPEDITOR: '',
        BIRTHDATE: '',
        NATIONALITY: '',
        ID_NUMBER: '',
        DOC_NUMBER: '',
        STATE_ADDRESS: '',
        TEST_GLOBAL_AUTHENTICITY_VALUE: '',
        TEST_GLOBAL_AUTHENTICITY_RATIO: '',
        SEX: '',
        SURNAME: '',
        FIRST_SURNAME: '',
        SECOND_SURNAME: '',
        Image1cut: '',
        Image2cut: '',
        ImagePhoto: '',
        ImageSignature: '',
        TEST_FACE_RECOGNITION_RATIO: '',
        TEST_FACE_RECOGNITION_VALUE: '',
        province_id: '',
        municipality_id: 0,
        postal_code: ''
      }
    };
  }

  withDNIData(dni: Partial<DNIData>): SetCheckInAdultBuilder {
    this.checkInData.dni = {...this.checkInData.dni, ...dni};
    return this;
  }

  withPersonalInfo(genero: string, name: string, surname: string, firstSurname: string, secondSurname: string, nationality: string): SetCheckInAdultBuilder {
    this.checkInData.dni.SEX = genero;
    this.checkInData.dni.NAME = name;
    this.checkInData.dni.SURNAME = surname;
    this.checkInData.dni.FIRST_SURNAME = firstSurname;
    this.checkInData.dni.SECOND_SURNAME = secondSurname;
    this.checkInData.dni.NATIONALITY = nationality;
    return this;
  }

  withDocument(idNumber: string, docNumber: string, type: string, expeditor: string): SetCheckInAdultBuilder {
    this.checkInData.dni.ID_NUMBER = idNumber;
    this.checkInData.dni.DOC_NUMBER = docNumber;
    this.checkInData.dni.TYPE = type;
    this.checkInData.dni.EXPEDITOR = expeditor;
    return this;
  }

  withDates(birthDate: string, expeditionDate: string, expiry: string): SetCheckInAdultBuilder {
    this.checkInData.dni.BIRTHDATE = birthDate;
    this.checkInData.dni.EXPEDITION_DATE = expeditionDate;
    this.checkInData.dni.EXPIRY = expiry;
    return this;
  }

  withAddress(street: string, city: string, state: string, postalCode: string, provinceId: string, municipalityId: number | null): SetCheckInAdultBuilder {
    this.checkInData.dni.STREET_ADDRESS = street;
    this.checkInData.dni.CITY_ADDRESS = city;
    this.checkInData.dni.STATE_ADDRESS = state;
    this.checkInData.dni.postal_code = postalCode;
    this.checkInData.dni.province_id = provinceId;
    this.checkInData.dni.municipality_id = municipalityId;
    return this;
  }

  withImages(image1: string, image2: string, photo: string, signature: string): SetCheckInAdultBuilder {
    this.checkInData.dni.Image1cut = image1;
    this.checkInData.dni.Image2cut = image2;
    this.checkInData.dni.ImagePhoto = photo;
    this.checkInData.dni.ImageSignature = signature;
    return this;
  }

  withVerification(authenticity: string, authenticityRatio: string, faceRecognition: string, faceRatio: string): SetCheckInAdultBuilder {
    this.checkInData.dni.TEST_GLOBAL_AUTHENTICITY_VALUE = authenticity;
    this.checkInData.dni.TEST_GLOBAL_AUTHENTICITY_RATIO = authenticityRatio;
    this.checkInData.dni.TEST_FACE_RECOGNITION_VALUE = faceRecognition;
    this.checkInData.dni.TEST_FACE_RECOGNITION_RATIO = faceRatio;
    return this;
  }

  withContract(contract: number): SetCheckInAdultBuilder {
    this.checkInData.contract_type_id = contract;
    return this;
  }

  withUpdatedFields(fields: string[]): SetCheckInAdultBuilder {
    this.checkInData.updated_fields = fields;
    return this;
  }

  enableImages(): SetCheckInAdultBuilder {
    this.checkInData.without_images = false;
    return this;
  }

  disableIcarVerification(): SetCheckInAdultBuilder {
    this.checkInData.icar_verified = false;
    return this;
  }

  build(): SetCheckInAdult {
    return {...this.checkInData};
  }
}
